<div class="w-full h-full p-1">
  <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
  <div class="grid grid-cols-12 gap-2">
    <!-- Listbox Section -->
    <div class="col-span-5">
      <p-listbox 
        scrollHeight="400px"
        [options]="apbData()?.apbAnnuli"
        [ngModel]="selectedAnnulus()"
        (onChange)="onAnnulusSelected($event.value)"
        optionLabel="name"
        dataKey="tubularStringId"
      ></p-listbox>
    </div>

    <!-- Switch and Fieldset Section -->
    @if (selectedAnnulus()) {
    <div class="col-span-7 space-y-2">
      <p-fieldset class="[&_.p-fieldset-legend]:hidden">
        <div class="flex items-center space-x-2 pb-3">
          <label for="isVented">
            Vented Annulus
          </label>
          <p-toggleSwitch
            inputId="isVented"
            [(ngModel)]="selectedAnnulus().isVented"
            (onChange)="updateAnnulus(selectedAnnulus())"
            [disabled]="!selectedAnnulus()">
          </p-toggleSwitch>
        </div>

        <div class="flex flex-col">
          <label for="tempAtPerfs">Maximum Allowed Hanger Pressure</label>
          <p-inputgroup>
              <p-inputNumber
                [minFractionDigits]="1"
                (onBlur)="updateAnnulus(selectedAnnulus())"
                [(ngModel)]="selectedAnnulus().maxAllowedHangerPressure"
                [class.opacity-50]="!selectedAnnulus().isVented"
                [class.pointer-events-none]="!selectedAnnulus().isVented"
              ></p-inputNumber>
            <p-inputgroup-addon>{{ pressureUnitLabel }}</p-inputgroup-addon>
          </p-inputgroup>
        </div>
      </p-fieldset>

      <div class="flex flex-col">
        <label for="tempAtPerfs">Volume Bleed Off at Hanger</label>
        <p-inputgroup>
            <p-inputNumber
              [minFractionDigits]="1"
              (onBlur)="updateAnnulus(selectedAnnulus())"
              [(ngModel)]="selectedAnnulus().bleedOffVolume"
            ></p-inputNumber>
          <p-inputgroup-addon>{{ volumeUnitLabel }}</p-inputgroup-addon>
        </p-inputgroup>
      </div>

      <br>
      <p-fieldset>
        <ng-template pTemplate="header">
          <div class="flex h-5">
            <p-toggleswitch (onChange)="updateAnnulus(selectedAnnulus())" inputId="isFormationLeakOff"
              [(ngModel)]="selectedAnnulus().isFormationLeakOff" binary="true">
            </p-toggleswitch>
            <label for="isFormationLeakOff" class="ml-2"> Formation Leak-Off</label>
          </div>
        </ng-template>

        <div class="space-y-2">
          <div class="flex flex-col">
            <label [class.opacity-50]="!selectedAnnulus().isFormationLeakOff">Leak-Off Depth</label>
            <p-inputgroup>
              <p-inputNumber [minFractionDigits]="1" [(ngModel)]="selectedAnnulus().leakOffDepth"
                (onBlur)="updateAnnulus(selectedAnnulus(), true)"
                [class.opacity-50]="!selectedAnnulus().isFormationLeakOff"
                [class.pointer-events-none]="!selectedAnnulus().isFormationLeakOff"/>
              <p-inputgroup-addon>{{ lengthUnitLabel }} MD</p-inputgroup-addon>

            </p-inputgroup>
            @if (
              leakOffDepthValidation &&
              selectedAnnulus().isFormationLeakOff &&
              selectedAnnulus().leakOffDepth &&
              (selectedAnnulus().leakOffDepth < leakOffDepthValidation.min ||
              selectedAnnulus().leakOffDepth > leakOffDepthValidation.max)
            ) {
              <p class="validation-error">
                Allowed range: {{ leakOffDepthValidation.min }} -
                {{ leakOffDepthValidation.max }} {{ lengthUnitLabel }} MD
              </p>
            }
          </div>

          <div class="flex flex-col">
            <label [class.opacity-50]="!selectedAnnulus().isFormationLeakOff">Leak-Off Density</label>
            <p-inputgroup>
              <p-inputNumber [minFractionDigits]="1" [(ngModel)]="selectedAnnulus().leakOffDensity"
                (onBlur)="updateAnnulus(selectedAnnulus(), false, true)"
                [class.opacity-50]="!selectedAnnulus().isFormationLeakOff"
                [class.pointer-events-none]="!selectedAnnulus().isFormationLeakOff"/>
              <p-inputgroup-addon>{{densityUnitLabel}}</p-inputgroup-addon>
            </p-inputgroup>
          </div>
        </div>

      </p-fieldset>

      <br> 
      <p-fieldset legend="Initial Conditions">
        <div>
          <label for="initialTemp">
            Initial Temperature
          </label>
          <p-select 
            filter
            filterBy="name"
            resetFilterOnHide="true"
            id="initialTemp"
            dataKey="id"
            [options]="initialTemperatureOperations()"
            optionValue="id"
            [disabled]="true" 
            [(ngModel)]="selectedAnnulus().initialOperationId"
            (onChange)="updateAnnulus(selectedAnnulus())"
            optionLabel="name"
            appendTo="body"
            class="mt-2 w-full">
          </p-select>
        </div>
      </p-fieldset>
    </div>
    }

    <!-- Final Conditions Section -->
    <div class="col-span-12">
      <p-fieldset legend="Final Conditions">
            <div class="flex flex-col space-y-2">
              <label for="thermalOperation">
                Thermal Operation
              </label>
              <p-select
                filter
                filterBy="name"
                resetFilterOnHide="true"
                id="thermalOperation" 
                dataKey="id" 
                [options]="thermalOperations()"
                [ngModel]="apbData()?.finalOperation" 
                (onChange)="updateFinalConditions($event.value)" 
                optionLabel="name"
                appendTo="body"
                class="w-full"
              ></p-select>
            </div>
      </p-fieldset>
    </div>

  </div>
</p-scrollPanel>
</div>
